import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import ChildWorkItemsIcon from '@atlaskit/icon/core/child-work-items';
import { token } from '@atlaskit/tokens';

const messages = defineMessages({
	iconLabel: {
		id: 'update-work-item-all-fields-action-renderer.ui.action-card.jira-issue-links-field.icon-label',
		defaultMessage: 'Issue links field icon',
		description: 'Label for the issue links field icon',
	},
});

export function IssueLinksFieldIcon(): React.JSX.Element {
	const { formatMessage } = useIntl();
	return (
		<ChildWorkItemsIcon
			label={formatMessage(messages.iconLabel)}
			size="small"
			color={token('color.icon.subtle')}
		/>
	);
}
